import { memo } from 'react';
import { HStack } from '@chakra-ui/react';

import IconButton from 'shared/IconButton';

const SliderControls = ({ slideNext, slidePrev, iconProps = null, ...props }) => (
  <HStack gap={{ mobile: '8px', laptop: '20px' }} hideBelow="tablet" {...props}>
    <IconButton
      direction="left"
      onClick={slidePrev}
      boxSize={{ laptop: '56px', tablet: '40px', mobile: '48px' }}
      {...iconProps}
    />
    <IconButton
      onClick={slideNext}
      boxSize={{ laptop: '56px', tablet: '40px', mobile: '48px' }}
      {...iconProps}
    />
  </HStack>
);

export default memo(SliderControls);
